export default "__VITE_ASSET__DeJdQujm__"